import { Params, json } from 'react-router-dom';
import { AdminNote, DemoNoteDataType, NoteDataType } from '../types/types';
import { API_BASE_URL } from '../services/APIService';

// Original admin note loader - Export both signatures for backward compatibility
export const NoteLoader = async (note_id: string): Promise<AdminNote | undefined> => {
  const accessToken = localStorage.getItem('accessToken');
  const response = await fetch(`${API_BASE_URL}/notes/${note_id}?origin=NoteDetailView`, {
    method: 'get',
    headers: new Headers({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    }),
  })
    .then(res => {
      if (res.status === 401) {
        throw json(
          {
            message: 'You are not authorized to access this resource.',
            cta: 'Login',
          },
          { status: 401 },
        );
      }
      return res.json();
    })
    .then((note: AdminNote) => {
      return note;
    })
    .catch(() => {
      throw json(
        {
          message: 'There has been an error. Please login again.',
          cta: 'Login',
        },
        { status: 500 },
      );
    });
  return response;
};

// Alias for the admin note loader for clarity
export const AdminNoteLoader = NoteLoader;

// Moved from NoteViewRevamp.tsx to break circular dependency
export const MainNoteLoader = async ({
  params,
}: {
  params: Params;
}): Promise<NoteDataType | null> => {
  const accessToken = localStorage.getItem('accessToken');
  const note = await fetch(`${API_BASE_URL}/notes/${params.noteId}?origin=NoteDetailView`, {
    method: 'get',
    headers: new Headers({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    }),
  })
    .then(res => {
      if (res.status === 401) {
        throw json(
          {
            message: 'You are not authorized to access this resource.',
            cta: 'Login',
          },
          { status: 401 },
        );
      }

      return res.json();
    })
    .then((data: NoteDataType) => {
      return data;
    })
    .catch(() => {
      throw json(
        {
          message: 'There has been an error. Please login again.',
          cta: 'Login',
        },
        { status: 500 },
      );
    });

  return note;
};

// Moved from NoteViewRevamp.tsx to break circular dependency
export const DemoNoteLoader = async ({
  params,
}: {
  params: Params;
}): Promise<DemoNoteDataType | null> => {
  const note = await fetch(`${API_BASE_URL}/demoNote/${params.noteId}`, {
    method: 'get',
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
  })
    .then(res => res.json())
    .then((data: DemoNoteDataType) => {
      return data;
    })
    .catch(() => {
      throw json(
        {
          message: 'There has been an error loading the demo note.',
          cta: 'Return to dashboard',
        },
        { status: 500 },
      );
    });

  return note;
};
